import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const formatMonth = month => {
  switch (month) {
  case '01':
    return 'Januar';
  case '02':
    return 'Februar';
  case '03':
    return 'Mars';
  case '04':
    return 'April';
  case '05':
    return 'Mai';
  case '06':
    return 'Juni';
  case '07':
    return 'Juli';
  case '08':
    return 'August';
  case '09':
    return 'September';
  case '10':
    return 'Oktober';
  case '11':
    return 'November';
  case '12':
    return 'Desember';
  }
};

const formatValue = value => {
  return {
    value: value,
    label: formatMonth(value.substring(5, 7)) + ' ' + value.substring(0, 4)
  };
};

const calculateRange = (from, to) => {
  let options = [];
  let fromYear = Number(from.substring(0, 4));
  let toYear = Number(to.substring(0, 4));
  let fromMonth = Number(from.substring(5, 7));
  let toMonth = Number(to.substring(5, 7));

  for (let n = fromYear; n <= toYear; n++) {
    let months = [];
    let minMonth = 1;
    let maxMonth = 12;
    if (n === fromYear) {
      minMonth = fromMonth;
    }
    if (n === toYear) {
      maxMonth = toMonth;
    }
    for (let l = minMonth; l <= maxMonth; l++) {
      months.push(formatValue(n + '-' + (l < 10 ? '0' + l : l)));
    }
    options.push({
      label: n,
      options: months
    });
  }

  window.calculateRange = calculateRange;

  return options;
};

const TimePicker = props => (
  <Select
    className={'time-picker ' + props.className}
    classNamePrefix='time-picker'
    options={calculateRange(props.min, props.max)}
    defaultValue={formatValue(props.value)}
    onChange={props.onChange}
  />
);

TimePicker.propTypes = {
  className: PropTypes.string,
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default TimePicker;



// WEBPACK FOOTER //
// ./src/component/Timepicker.js